import { createSlice } from "@reduxjs/toolkit";
import { authorizedUserAction } from "./authorizedUsers.actions";

// Define types Here
interface initialStateTypes {

  clientDetails : any,
  error: string

}

// Define States Here
const initialState : initialStateTypes = {
    clientDetails : [],
    error: ""

}

// ------ Project Overview Reducer for managing Project overview state. ------
const authorizedUsersSlice = createSlice({
  name: "authorizedUsers",
  initialState,
  reducers: {
  },
  extraReducers: (builder) =>{
  builder

  //------------- Cases of Client Details Api Data ------------ 
  .addCase(authorizedUserAction.getCustomerUsersAction.pending, (state,) => {
    state.clientDetails = [];
  })
  .addCase(authorizedUserAction.getCustomerUsersAction.fulfilled, (state, action) => {
    state.clientDetails = action.payload.data;
  })
  .addCase(authorizedUserAction.getCustomerUsersAction.rejected, (state, action) => {
    state.clientDetails = [];
  })

  // ------------- Cases of Remove Customer User Api Data ------------ 
  .addCase(authorizedUserAction.removeCustomerUserAction.pending, (state,) => {
    state.error = "";
  })
  .addCase(authorizedUserAction.removeCustomerUserAction.fulfilled, (state, action) => {
    state.clientDetails = action.payload.data;
  })
  .addCase(authorizedUserAction.removeCustomerUserAction.rejected, (state, action : any) => {
    state.error = action?.payload?.data?.message || "";
  })
  }

});

export default authorizedUsersSlice.reducer;

